export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            手机观影
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            随时随地，口袋里的私人影院
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="rounded-2xl bg-gradient-to-br from-foreground-900 via-foreground-800 to-foreground-900 overflow-hidden border border-foreground-700/30">
            <div className="flex flex-col lg:flex-row items-center">
              <div className="lg:w-1/2 p-8 md:p-10 lg:p-12">
                <div className="w-14 h-14 flex items-center justify-center bg-primary-500/20 rounded-xl mb-5">
                  <i className="ri-smartphone-line text-2xl text-primary-400"></i>
                </div>
                <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50 mb-4">
                  麻花影院 APP
                </h3>
                <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-6">
                  专为移动观影优化的麻花影院免费观看APP，支持 iOS 和 Android 双平台。更流畅的播放体验、更便捷的离线缓存、更智能的个性化推荐。手机端享受和电脑端完全一致的免费影视内容，高清不卡顿。
                </p>
                <div className="flex flex-wrap items-center gap-4 mb-6">
                  <div className="flex items-center gap-2 text-foreground-300 text-sm">
                    <i className="ri-checkbox-circle-fill text-primary-400"></i>
                    <span>1080P高清画质</span>
                  </div>
                  <div className="flex items-center gap-2 text-foreground-300 text-sm">
                    <i className="ri-checkbox-circle-fill text-primary-400"></i>
                    <span>离线缓存观看</span>
                  </div>
                  <div className="flex items-center gap-2 text-foreground-300 text-sm">
                    <i className="ri-checkbox-circle-fill text-primary-400"></i>
                    <span>智能推荐引擎</span>
                  </div>
                  <div className="flex items-center gap-2 text-foreground-300 text-sm">
                    <i className="ri-checkbox-circle-fill text-primary-400"></i>
                    <span>投屏电视播放</span>
                  </div>
                </div>
                <div className="flex flex-wrap gap-3">
                  <a
                    href="#"
                    className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-apple-line text-lg"></i>
                    iOS 下载
                  </a>
                  <a
                    href="#"
                    className="inline-flex items-center gap-2 px-6 py-2.5 bg-background-50/10 hover:bg-background-50/20 border border-background-50/20 text-background-50 font-medium rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-android-line text-lg"></i>
                    Android 下载
                  </a>
                </div>
              </div>
              <div className="lg:w-1/2 flex justify-center items-end pt-6 lg:pt-0 px-6 lg:px-0">
                <div className="relative w-56 md:w-64">
                  <img
                    src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20movie%20streaming%20app%20interface%20on%20dark%20screen%2C%20warm%20cinematic%20UI%20design%20with%20amber%20accents%2C%20film%20poster%20thumbnails%2C%20clean%20modern%20layout%2C%20dark%20mode%20theme%2C%20isolated%20on%20transparent%20background&width=600&height=1000&seq=mahua-app-01&orientation=portrait"
                    alt="麻花影院APP界面"
                    className="w-full object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}